import ongletClass from "@/class/onglets/onglet"
import tools from "@/class/tools";
import router from '@/router'

export const storedOnglets = [];

let ONGLET_VERIONS = "0.2"
export const onglets = {
    
    add (onglet){
        
        if(this.exist(onglet)){
            
            let existOnglet = this.get(onglet);
            this.update(existOnglet);
            if(onglet.active){
                this.active(existOnglet);
            }
            return onglet;
        }
        
        let key = this.getActiveIndex();
        if(key >= 0) {
            storedOnglets.splice(key + 1, 0, onglet);
        }else{
            storedOnglets.push(onglet);
        }
        
        if(onglet.active){
            this.active(onglet);
        }
        
        this.save();
        
        return onglet;
    },
    
    update(onglet){
        let ong = {};
        storedOnglets.map((o) => {
            if(o.router === onglet.router){
                o.updateData(onglet)
                ong = o;
            }
        });
        
        this.save();
        
        return ong;
    },
    
    exist(onglet){
        return storedOnglets.filter(o => o.router === onglet.router).length > 0;
    },
    get(onglet){
        return storedOnglets.find(o => o.router === onglet.router);
    },
    find(route){
          return storedOnglets.filter(o => o.router === route);
    },
    getActive(){
        return storedOnglets.find(o => o.active);
    },
    getActiveIndex(){
        return storedOnglets.findIndex(o => o.active);
    },
    
    close(onglet){
        
        onglet.destroy = true;
        
        let self = onglet.router === this.getActive().router
        storedOnglets.forEach(o => {
            console.log(o.router,onglet.router)
        })
        let key = storedOnglets.findIndex(o => o.router === onglet.router);
        console.log(key)
        if(key < 0) return;
        storedOnglets.splice(key ,1);
        
        if(self) {
            console.log(storedOnglets[key-1])
            if(key > 0) {
                this.active(storedOnglets[key-1])
            }else{
                this.active(storedOnglets[0])
            }
        }
        
        this.save();
    },
    
    save(){
        tools.localStorage("onglets_"+ONGLET_VERIONS,storedOnglets);
    },
    
    active(onglet){
        if(!onglet){
            router.push("/home");
            return;
        }
        storedOnglets.map(o => o.active = false);
        
        onglet.active = true;
        if(router.currentRoute.path !== onglet.router) {
            router.push(onglet.router);
        }
    },
    
    activeLast(){
        if(!storedOnglets[storedOnglets.length - 1]){
            return router.push("/home")
        }
        this.active(storedOnglets[storedOnglets.length - 1])
    }
}

// initialisation
// let savedOnglet = tools.localStorage("onglets_"+ONGLET_VERIONS);
//
// if(savedOnglet.length > 0){
//     savedOnglet.forEach((o) => {
//         storedOnglets.push(new ongletClass().setData(o))
//     })
// }